module.exports = __webpack_public_path__ + "static/img/activity3.b91ec22.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/weicai/aboutWe/activity3.jpg
// module id = H1fh
// module chunks = 3